import { Component, OnInit, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentSwitcherDirective } from '@anecdotes/design-system/component-switcher';
import { CdkPortalService } from '../../services/cdk-portal-service/cdk-portal.service';

@Component({
  selector: 'app-alert-modal-window',
  templateUrl: './alert-modal-window.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertModalWindowComponent implements OnInit {
  @HostBinding('class')
  private classes = 'block w-150 h-60';

  type$: Observable<string>;
  text$: Observable<string>;
  icon$: Observable<string>;

  constructor(private componentsSwitcher: ComponentSwitcherDirective, private cdkPortalService: CdkPortalService) {}

  ngOnInit(): void {
    this.type$ = this.componentsSwitcher.sharedContext$.pipe(map((ctx) => ctx.type));
    this.text$ = this.componentsSwitcher.sharedContext$.pipe(map((ctx) => ctx.text));
    this.icon$ = this.type$.pipe(map((type) => this.getAlertIconByAlertType(type)));
  }

  close(): void {
    this.cdkPortalService.closePortal();
  }

  private getAlertIconByAlertType(alertType: string): string {
    switch (alertType) {
      case 'success': {
        return 'status_complete';
      }
      default:
        return null;
    }
  }
}
